module.exports = __webpack_public_path__ + "static/img/android-chrome-192x192.fd5b2bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons/android-chrome-192x192.png
// module id = 219
// module chunks = 1